<section class="main-section">
    <section class="border-0 h-100 w-100 bg-transparent">
        <div class="text-center">

            <!-- main panel -->

            <div class="card h-100 shadow">
                <div class="card-body">

                    <h2 class="mb-3 d-none d-lg-block">{{ 'Harmonogram akademického roka' | translate }}</h2>

                    <app-zapisny-list-selector></app-zapisny-list-selector>

                    <ng-container *ngIf="upozornenia?.length; else noAlerts">
                        <div class="d-flex flex-column align-items-center">
                            <div class="d-flex flex-column align-items-start">

                            @for (message of upozornenia; track message) {

                                <div class="mb-3 text-start">
                                    <div class="d-flex align-items-center">
                                        <mat-icon matListItemIcon class="text-black-50 me-2">info</mat-icon>
                                        <span class="fw-bolder">{{message.text}}</span>
                                    </div>
                                    <div class="ms-5">
                                        <div class="fw-bold text-black-50">{{ message.odDatumu }} - {{ message.doDatumu }}</div>
                                        @if (message.popis) {
                                            <div class="small">{{message.popis}}</div>
                                        }
                                    </div>
                                </div>

                            }

                            </div>
                        </div>
                    </ng-container>

                    <ng-template #noAlerts>
                        <p class="text-muted">{{ 'Žiadne upozornenia' | translate }}</p>
                    </ng-template>
                </div>
            </div>


        </div>

    </section>
</section>



